import queryString from 'query-string';
import Cookies from 'js-cookie';

/**
 * 获取URL参数
 */
export function parseQuery() {
    return queryString.parseUrl(window.location.href).query;
}

/**
 * 获取URL指定参数
 */
export function getUrlParam(urlSearch, param) {
    const regex = new RegExp(`(?:\\b${param}\\b|${param})`, 'i');
    const match = regex.exec(urlSearch);
    return match ? decodeURIComponent(match[1]) : null;
}

/**
 * 获取url中的company参数值  
 */
export function getCompanyUrlParam(){
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    return searchParams.get('company') ? parseInt(searchParams.get('company')) : null;
};

/**
 * 校验登录状态
 * @param permits
 */
export const checkLogin = (): boolean => {
    const hasLocalUser = localStorage.getItem('CRM_WEB@user') !== null;
    const hasRoleCookie = !!Cookies.get('userRole');
    return hasLocalUser && hasRoleCookie;
};
